// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Timer_wrap__UhaTx","text":"Timer_text__KaZGX","button":"Timer_button__FYhHF"};